export enum PartnersWithCustom {
  Default = 0,
  MarkApp = 360
}